<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="[]"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="false"
></app-st-banner>
<div class="container-fluid h-100">
  <br><br><br><br><br>
  <div class="row h-100">
    <div class="col section-content">
      <div class="content-container">
        <div class="icon-circle">
          <i class="bi bi-box-arrow-in-left">
          </i>
        </div>
        <app-st-header-title [inputVal]="'You have been signed out.'"></app-st-header-title>
        <app-st-span [inputVal]="'Click to return to sign in page'"></app-st-span>
        <br>
        <br>
        <app-st-button [label]="'Login'" [primary]="true" (onClick)="login()"></app-st-button>
      </div>
    </div>
  </div>

</div>
